<template>
    <div class="consent-pd">
        <div class="consent-container">
            <textarea
                ref="consentTextarea"
                class="form-control consent-textarea"
                :rows="rows"
                readonly
                @scroll="checkConsentScroll"
                :value="consentContent"
                placeholder="Прокрутите текст полностью для активации кнопки регистрации..."
            >
            </textarea>
        </div>
        
        <div class="mt-2">
            <small v-if="!consentScrolled" class="text-muted">
                <i class="fas fa-info-circle mr-1"></i>
                Прокрутите текст полностью для активации кнопки регистрации
            </small>
            <small v-else class="text-success">
                <i class="fas fa-check-circle mr-1"></i>
                Текст согласия полностью прочитан ✓
            </small>
        </div>
    </div>
</template>
  
<script>
  export default {
    name: "ConsentPersonalData",
    props: {
      rows: {
        type: Number,
        default: 7
      },
      userData: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        consentScrolled: false,
        consentContent: ''
      };
    },
    mounted() {
      this.generateConsentContent();
    },
    watch: {
      userData: {
        handler() {
          this.generateConsentContent();
        },
        deep: true
      }
    },
    methods: {
      generateConsentContent() {
        const data = this.userData;
        
        // Формируем ФИО (единственный placeholder, который оставляем)
        const fullName = [
          data.last_name || '',
          data.first_name || '',
          data.middle_name || ''
        ].filter(Boolean).join(' ') || '[Ф.И.О. полностью]';
        

        
        // Паспортные данные с подписями
        let passportText = '';
        if (data.passport_series || data.passport_number || data.passport_issue_date || data.passport_issued_by || data.passport_department_code) {
          const passportDetails = [];
          
          if (data.passport_series) {
            passportDetails.push(`серия: ${data.passport_series}`);
          }
          if (data.passport_number) {
            passportDetails.push(`номер: ${data.passport_number}`);
          }
          if (data.passport_issue_date) {
            passportDetails.push(`когда выдан: ${data.passport_issue_date}`);
          }
          if (data.passport_issued_by) {
            passportDetails.push(`кем выдан: ${data.passport_issued_by}`);
          }
          if (data.passport_department_code) {
            passportDetails.push(`код подразделения: ${data.passport_department_code}`);
          }
          
          passportText = `паспорт гражданина РФ ${passportDetails.join(', ')}`;
        }
        
        // Дополнительные данные с подписями
        let additionalData = [];
        
        if (data.snils) {
          additionalData.push(`СНИЛС: ${data.snils}`);
        }
        
        if (data.inn) {
          additionalData.push(`ИНН: ${data.inn}`);
        }
        
        if (data.birth_date) {
          additionalData.push(`дата рождения: ${data.birth_date}`);
        }
        
        if (data.birth_place) {
          additionalData.push(`место рождения: ${data.birth_place}`);
        }
        
        if (data.phone) {
          additionalData.push(`телефон: ${data.phone}`);
        }
        
        if (data.email) {
          additionalData.push(`электронная почта: ${data.email}`);
        }
        
        // Собираем основной текст с подписями полей
        let mainText = `Я, ${fullName}`;
        
        // Адрес регистрации с подписью
        if (data.registration_address) {
          mainText += `, адрес регистрации: ${data.registration_address}`;
        }
        
        // Адрес фактического проживания с подписью
        if (data.actual_address) {
          mainText += `, адрес фактического проживания: ${data.actual_address}`;
        }
        
        // Паспортные данные с подписью
        if (passportText) {
          mainText += `, ${passportText}`;
        }
        
        // Добавляем дополнительные данные с подписями
        if (additionalData.length > 0) {
          mainText += `, ${additionalData.join(', ')}`;
        }
        
        mainText += `, в соответствии со ст. 9 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», свободно, своей волей и в своем интересе даю Оператору – Обществу с ограниченной ответственностью «ТАНАИС Брокер» (ИНН 7731309397, ОГРН 1167746200775), юридический адрес: 121552, г. Москва, вн. тер. г. муниципальный округ Кунцево, ш. Рублевское, д.101, кв.242, согласие на обработку следующих моих персональных данных для цели:`;
        
        this.consentContent = `СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ

г. Москва, ${new Date().toLocaleDateString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        })}

${mainText}

Цель обработки ПД: Заключение, исполнение и прекращение гражданско-правовых и иных непосредственно связанных с ними отношений, осуществление ООО «ТАНАИС Брокер» возложенных на него законодательством функций, обязанностей и полномочий в рамках гражданско-правовых отношений, выполнение физическим лицом работ/услуг.

Перечень ПД: фамилия, имя, отчество; пол; дата, месяц и год рождения; место рождения; гражданство; реквизиты паспорта; адрес места жительства / фактического проживания; СНИЛС; ИНН; документы об образовании; номер телефона; электронная почта.

Подтверждаю, что представленные мной персональные данные не содержат данных, касающихся моей расовой и национальной принадлежности, политических взглядов, религиозных или философских убеждений, а также интимной жизни.

Настоящее Согласие предоставляется на осуществление всех действий в отношении моих персональных данных, которые необходимы для достижения указанных выше целей, включая сбор, запись, систематизацию, накопление, хранение, уточнение, использование, передачу, блокирование, удаление, уничтожение персональных данных.

Согласие действует с момента его подписания в течение срока действия трудового договора и может быть отозвано мной при предоставлении в Общество письменного заявления.

Обязуюсь сообщать в 14-дневный срок об изменении персональных данных.

Юридические последствия отказа предоставить персональные данные и / или дать согласие на их обработку мне разъяснены.

${fullName} ${new Date().toLocaleDateString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric"
        })}`;
      },
      
      checkConsentScroll() {
        const textarea = this.$refs.consentTextarea;
        if (textarea) {
          const scrollTop = textarea.scrollTop;
          const scrollHeight = textarea.scrollHeight;
          const clientHeight = textarea.clientHeight;
          
          // Проверяем, что пользователь прокрутил до конца
          if (scrollTop + clientHeight >= scrollHeight - 5) {
            this.consentScrolled = true;
            this.$emit('consent-scrolled', true);
            console.log('Согласие полностью прокручено!');
          }
        }
      }
    }
  };
</script>
  
<style scoped>
  .consent-pd {
    max-width: 900px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    font-size: 14px;
  }

  .consent-container {
    position: relative;
  }

  .consent-textarea {
    font-family: monospace;
    font-size: 12px;
    line-height: 1.4;
    resize: vertical;
    min-height: 150px;
  }

  .mt-2 {
    margin-top: 0.5rem;
  }

  .text-muted {
    color: #6c757d;
  }

  .text-success {
    color: #28a745;
  }

  .mr-1 {
    margin-right: 0.25rem;
  }
</style>